module.exports = __webpack_public_path__ + "static/media/question_active.d4b61d90.svg";